<template>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">Company Profile</div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true"
                                aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel"
                                style="width: 550px" :breakpoints="{ '960px': '80vw' }">
                                <div class="grid field">
                                    <div class="row">
                                        <i class="pi pi-plus-circle" />
                                        {{ this.$formatDateTime(header.CreatedDate) }}
                                    </div>
                                    <div class="row">&nbsp;by {{ header.CreatedBy }}</div>
                                </div>
                                <div class="grid field" v-if="header.EditedDate">
                                    <div class="row">
                                        <i class="pi pi-pencil" />
                                        {{ this.$formatDateTime(header.EditedDate) }}
                                    </div>
                                    <div class="row">&nbsp;by {{ header.EditedBy }}</div>
                                </div>
                                <div class="grid field" v-if="header.DeletedDate">
                                    <div class="row">
                                        <i class="pi pi-trash" />
                                        {{ this.$formatDateTime(header.DeletedDate) }}
                                    </div>
                                    <div class="row">&nbsp;by {{ header.DeletedBy }}</div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-save" label="Save" class="p-button-success mr-2" @click="confirm($event)"
                            v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW
                            " />
                        <Button icon="pi pi-trash" label="Delete" class="p-button-danger mr-2" @click="confirm($event)"
                            v-if="mode == this.$FORM_MODE_DELETE" />
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <TabView>
                        <TabPanel header="Header Company">
                            <div class="grid">
                                <div class="col-6">
                                    <div class="field grid">
                                        <label for="Country" class="col-4">{{ $t("country") }}</label>
                                        <div class="col-8 md-8">
                                            <CustomSelect class="p-inputtext-sm" v-model="header.Country" v-if="header"
                                                :url="this.$API_URL + 'list/country_code'" :minLength="0" :params="{}"
                                                :class="{ 'p-invalid': submitted && !header.Country }"
                                                :disabled="mode != this.$FORM_MODE_CREATE"
                                                :readonly="mode != this.$FORM_MODE_CREATE" />
                                            <small v-if="header &&
                            !header.Country &&
                            submitted &&
                            mode != this.$FORM_MODE_DELETE
                            " class="p-error">{{ $t("is_required").replace("Value", $t("country"))
                                                }}
                                            </small>
                                            <Skeleton v-else-if="!header" />
                                        </div>
                                    </div>
                                    <div class="field grid">
                                        <label for="Type" class="col-4">{{ $t("type") }}</label>
                                        <div class="col-8 md-8">
                                            <CustomSelect class="p-inputtext-sm" v-model="header.Type" v-if="header"
                                                :url="this.$API_URL + 'list/company_type'" :minLength="0" :params="{}"
                                                :class="{ 'p-invalid': submitted && !header.Type }"
                                                :disabled="mode != this.$FORM_MODE_CREATE"
                                                :readonly="mode != this.$FORM_MODE_CREATE" />
                                            <small v-if="header &&
                            !header.Type &&
                            submitted &&
                            mode != this.$FORM_MODE_DELETE
                            " class="p-error">{{ $t("is_required").replace("Value", $t("type")) }}
                                            </small>
                                            <Skeleton v-else-if="!header" />
                                        </div>
                                    </div>
                                    <div class="field grid">
                                        <label for="Name" class="col-4">{{ $t("comp_name") }}</label>
                                        <div class="col-8 md-8">
                                            <InputText name="Name" v-model="header.Name" type="text"
                                                :placeholder="$t('comp_name')" v-if="header"
                                                :class="{ 'p-invalid': submitted && !header.Name }"
                                                :disabled="mode != this.$FORM_MODE_CREATE"
                                                :readonly="mode != this.$FORM_MODE_CREATE" />
                                            <small v-if="header &&
                            !header.Name &&
                            submitted &&
                            mode != this.$FORM_MODE_DELETE
                            " class="p-error">{{ $t("is_required").replace("Value",
                            $t("comp_name")) }}
                                            </small>
                                            <Skeleton v-else-if="!header" />
                                        </div>
                                    </div>
                                    <div class="field grid">
                                        <label for="Code" class="col-4">{{ $t("comp_code") }}</label>
                                        <div class="col-8 md-8">
                                            <InputText name="Code" v-model="header.Code" type="text"
                                                :placeholder="$t('comp_code')" v-if="header"
                                                :class="{ 'p-invalid': submitted && !header.Code }"
                                                :disabled="mode != this.$FORM_MODE_CREATE"
                                                :readonly="mode != this.$FORM_MODE_CREATE" />
                                            <small v-if="header &&
                            !header.Code &&
                            submitted &&
                            mode != this.$FORM_MODE_DELETE
                            " class="p-error">{{ $t("is_required").replace("Value",
                            $t("comp_code")) }}
                                            </small>
                                            <Skeleton v-else-if="!header" />
                                        </div>
                                    </div>
                                    <div class="field grid">
                                        <label for="Location" class="col-4">{{ $t("location") }}</label>
                                        <div class="col-8 md-8">
                                            <InputText name="Location" v-model="header.Location" required="true"
                                                type="text" :placeholder="$t('location')" v-if="header"
                                                :class="{ 'p-invalid': submitted && !header.Location }" :disabled="mode != this.$FORM_MODE_CREATE &&
                            mode != this.$FORM_MODE_EDIT
                            " />
                                            <small v-if="header &&
                            !header.Location &&
                            submitted &&
                            mode != this.$FORM_MODE_DELETE
                            " class="p-error">{{ $t("is_required").replace("Value", $t("desc")) }}
                                            </small>
                                            <Skeleton v-else-if="!header" />
                                        </div>
                                    </div>
                                    <div class="field grid">
                                        <label for="Description" class="col-4">{{ $t("desc") }}</label>
                                        <div class="col-8 md-8">
                                            <InputText name="Description" v-model="header.Description" required="true"
                                                type="text" :placeholder="$t('desc')" v-if="header"
                                                :class="{ 'p-invalid': submitted && !header.Description }" :disabled="mode != this.$FORM_MODE_CREATE &&
                            mode != this.$FORM_MODE_EDIT
                            " />
                                            <small v-if="header &&
                            !header.Description &&
                            submitted &&
                            mode != this.$FORM_MODE_DELETE
                            " class="p-error">{{ $t("is_required").replace("Value", $t("desc")) }}
                                            </small>
                                            <Skeleton v-else-if="!header" />
                                        </div>
                                    </div>
                                    <div class="field grid">
                                        <label for="Lead" class="col-4">{{ $t("lead") }}</label>
                                        <div class="col-8 md-8">
                                            <CustomSelect class="p-inputtext-sm" v-model="header.Lead" v-if="header"
                                                :url="this.$API_URL + 'list/userbycompany'" :minLength="0"
                                                :params="{ companyId: header.Id }" :filter="true"
                                                :class="{ 'p-invalid': submitted && !header.Lead }"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                :readonly="mode != this.$FORM_MODE_CREATE" />
                                            <small v-if="header &&
                            !header.Lead &&
                            submitted &&
                            mode != this.$FORM_MODE_DELETE
                            " class="p-error">{{ $t("is_required").replace("Value", $t("lead"))
                                                }}
                                            </small>
                                            <Skeleton v-else-if="!header" />
                                        </div>
                                    </div>
                                    <div class="field grid" v-if="this.isAdmin == 'Y'">
                                        <label for="IsWilmar" class="col-4">{{ $t("iswilmar") }}</label>
                                        <div class="col-8 md-8">
                                            <YNCheckbox v-model="header.IsWilmar" :disabled="mode != this.$FORM_MODE_CREATE &&
                            mode != this.$FORM_MODE_EDIT
                            " v-if="header" :binary="true" />
                                            <small v-if="header &&
                            !header.IsWilmar &&
                            submitted &&
                            mode != this.$FORM_MODE_DELETE
                            " class="p-error">
                                            </small>
                                            <Skeleton v-else-if="!header" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel header="Department">
                            <Department :dataArray="header.CompanyDepartments" :dataModel="departmentmodel"
                                v-if="header" :header="header" :mode="mode" />
                        </TabPanel>
                        <TabPanel header="Admin Company">
                            <CompanyAdmin :dataArray="header.CompanyAdmins" :dataModel="admincompanymodel" v-if="header"
                                :header="header" :mode="mode" />
                        </TabPanel>
                        <TabPanel header="Linked Company">
                            <CompanyLinked :dataArray="header.CompanyLinkeds1" :dataModel="companylinkedmodel"
                                v-if="header" :header="header" :mode="mode" />
                            <CompanyLinked2 :dataArray="header.CompanyLinkeds2" :dataModel="companylinkedmodel2"
                                v-if="header" :header="header" :mode="mode" />
                        </TabPanel>
                        <TabPanel header="Area Classification" v-if="this.IsWilmar == 'Y'">
                            <AreaClassification :dataArray="header.RestrictedAreas" :dataModel="areaclassificationmodel"
                                v-if="header" :header="header" :mode="mode" />
                        </TabPanel>
                        <TabPanel header="Suspension" v-if="this.IsWilmar == 'Y'">
                            <Suspension :dataArray="header.CompanySuspends" :dataModel="suspendedmodel" v-if="header"
                                :header="header" :mode="mode" />
                        </TabPanel>
                        <TabPanel header="Permit Manager" v-if="this.IsWilmar == 'Y'">
                            <PermitVersion :dataArray="header.CompanyPermits" :dataModel="permitversionmodel"
                                v-if="header" :header="header" :mode="mode" />
                        </TabPanel>
                        <TabPanel header="Setting" v-if="this.IsWilmar == 'Y'">
                            <CompanySetting :dataArray="header.CompanySettings" :dataModel="companysettingmodel"
                                v-if="header" :header="header" :mode="mode" />
                        </TabPanel>
                    </TabView>
                </div>
            </template>
        </Card>
    </form>
</template>


<script>
import CompanyAdmin from './_CompanyAdmin.vue';
import Department from './_CompanyDepartment.vue';
import CompanyLinked from './_LinkedCompany.vue';
import CompanyLinked2 from './_LinkedCompany2.vue';
import AreaClassification from './_AreaClassification.vue';
import Suspension from './_Suspension.vue';
import PermitVersion from './_PermitVersion.vue';
import CompanySetting from './_CompanySetting.vue';

export default {
    name: "Editor",
    components: {
        CompanyAdmin: CompanyAdmin,
        Department: Department,
        CompanyLinked: CompanyLinked,
        CompanyLinked2: CompanyLinked2,
        AreaClassification: AreaClassification,
        Suspension: Suspension,
        PermitVersion: PermitVersion,
        CompanySetting: CompanySetting
    },
    data() {
        return {
            indexName: "CompanyProfileIndex",
            url: this.$API_URL + "companyprofile/",
            header: null,
            departmentmodel: null,
            admincompanymodel: null,
            companylinkedmodel: null,
            companylinkedmodel2: null,
            areaclassificationmodel: null,
            suspendedmodel: null,
            permitversionmodel: null,
            companysettingmodel: null,
            companyId: this.$store.getters.getCompanyId,
            isAdmin: this.$store.getters.getIsAdmin,
            IsWilmar: null,
            mode: "Edit",
            submitted: false,
            id: 0,
            formEditable: true,
        };
    },
    methods: {
        getData() {
            var self = this;
            this.$axios
                .get(this.url + this.id)
                .then((response) => {

                    self.header = response.data.data.header;
                    self.header.mode = self.mode;
                    self.departmentmodel = response.data.data.department;
                    self.admincompanymodel = response.data.data.companyadmin;
                    self.companylinkedmodel = response.data.data.companylinked;
                    self.companylinkedmodel2 = response.data.data.companylinked2;
                    self.areaclassificationmodel = response.data.data.restrictedarea;
                    self.suspendedmodel = response.data.data.companysuspend;
                    self.permitversionmodel = response.data.data.companypermit;
                    self.companysettingmodel = response.data.data.companysetting;
                    self.IsWilmar = response.data.data.header.IsWilmar;
                    //console.log(self.header);
                })
                .catch(function (error) {
                    //console.log(error);
                });
        },
        saveData() {
            this.$emit("blockBody");
            var self = this;
            this.$axios
                .post(this.url, this.header)
                .then((response) => {
                    if (response.data.success) {

                        if (self.mode == this.$FORM_MODE_DELETE) {
                            self.$emit("unblockBody");
                            self.$toast.add({ severity: 'success', summary: 'Data Deleted', detail: 'Data in Company ' + self.header.Code + " has been saved successfully", life: 3000 });
                            // this.$router.push({
                            //     name: this.indexName,
                            //     params: {
                            //         showToast: true,
                            //         severity: "success",
                            //         summary: "Data Deleted",
                            //         detail:
                            //             "Company " +
                            //             self.header.Code +
                            //             " has been deleted successfully",
                            //         life: 3000,
                            //     },
                            // });
                        } else {
                            self.$emit("unblockBody");
                            self.$toast.add({ severity: 'success', summary: 'Confirm', detail: 'Data in Company ' + self.header.Code + " has been saved successfully", life: 3000 });
                            self.getData();
                            //     this.$router.push({
                            //         name: this.indexName,
                            //         params: {
                            //             showToast: true,
                            //             severity: "success",
                            //             summary: "Data Saved",
                            //             detail:
                            //                 "Company " +
                            //                 self.header.Code +
                            //                 " has been saved successfully",
                            //             life: 3000,
                            //         },
                            //     });
                        }
                    } else {
                        self.showError("Error Saving Data", response.data.message);
                    }
                })
                .catch(function (error) {
                    this.showError("Error Saving Data", error);
                });
        },
        showError(summary, message) {
            this.$emit("unblockBody");
            this.$toast.add({
                severity: "error",
                summary: summary,
                detail: message,
                life: 3000,
            });
        },
        backToIndex() {
            this.$router.push({ path: "/CompanyProfile/Index" });
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        confirm(event) {
            this.submitted = true;
            if (
                !this.header.Country ||
                !this.header.Type ||
                !this.header.Name ||
                !this.header.Code ||
                !this.header.Location ||
                !this.header.Description
            ) {
                return false;

            } else {
                this.$confirm.require({
                    target: event.currentTarget,
                    message: "Are you sure?",
                    icon: "pi pi-exclamation-triangle",
                    accept: () => {
                        this.saveData();
                    },
                    reject: () => { },
                });
            }

        },
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? "row-hidden" : null;
        },
        addDetail() {
            var newDetail = this.detail;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };

            this.header.Locations.push(det);
        },
        deleteDetail(event) {
            if (event) {
                var detail = this.header.Locations[event.index];
                if (detail.mode == this.$FORM_MODE_CREATE)
                    this.header.Locations.splice(this.header.Locations.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditComplete(event) {
            this.editDetail(event.index);
        },
        editDetail(index) {
            if (this.header && this.header.Details) {
                let mode = this.header.Details[index].mode;
                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.Details[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
    },
    created() {
        //this.mode = this.mode;
        this.id = this.companyId ?? 0;

        this.getData();
    },
};
</script>